import { get, post } from './client';

export const createApprovalRequest = (data) => post('/workflow-approvals', data);

export const listApprovalRequests = (params = {}) => get('/workflow-approvals', params);

export const getClientApprovalStatus = (clientId) => get(`/workflow-approvals/client/${clientId}`);

export const approveRequest = (approvalId) => post(`/workflow-approvals/${approvalId}/approve`);

export const rejectRequest = (approvalId, rejectionReason) =>
  post(`/workflow-approvals/${approvalId}/reject`, { rejection_reason: rejectionReason });

export const listAssignableUsers = (roleCode) => get('/workflow-approvals/assignable-users', { role_code: roleCode });
